export default "__VITE_ASSET__5bda41b0__"